import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwTablet, toVwMobile, transitionDefault } from '../../../../../utils/styles';
import mq from '@/utils/media-queries';
import { SLIDE_SIZE_DESKTOP, SLIDE_SIZE_MOBILE, SLIDE_SIZE_TABLET } from '../constants';

const Styled = styled.div`
  && {
    background-color: ${props => props.theme.colorBright};
    text-align: center;
    padding: ${toVw(120)} ${toVw(108)} 0;
    box-sizing: border-box;
    opacity: 0.35;
    ${transitionDefault};
    will-change: opacity;
    height: ${toVw(SLIDE_SIZE_DESKTOP)};

    ${props =>
      props.active &&
      css`
        opacity: 1;
      `};

    ${mq.tablet(css`
      padding: ${toVwTablet(80)} ${toVwTablet(72)} 0;
      height: ${toVwTablet(SLIDE_SIZE_TABLET)};
    `)};

    ${mq.mobile(css`
      padding: ${toVwMobile(80)} ${toVwMobile(72)} 0;
      height: ${toVwMobile(SLIDE_SIZE_MOBILE)};
    `)};
  }
`;

const StyledMedia = styled.video`
  && {
    display: inline-block;
    max-width: 65%;
    pointer-events: none;
  }
`;

const Text = styled.div`
  position: relative;
  font-size: ${toVw(48)};
  color: ${props => props.theme.colorDark};
  z-index: 1;

  ${mq.tablet(css`
    font-size: ${toVwTablet(32)};
  `)};

  ${mq.mobile(css`
    font-size: ${toVwMobile(32)};
  `)};
`;

class Slide extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    media: PropTypes.object.isRequired,
    active: PropTypes.bool,
  };

  state = {
    active: false,
  };

  componentDidMount() {
    if (this.props.active && this.slideHasActiveClass()) {
      this.setState({ active: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active !== this.props.active) {
      if (nextProps.active && this.slideHasActiveClass()) {
        this.setState({ active: true });
      } else {
        this.setState({ active: false });
      }
    }
  }

  slideHasActiveClass = () => this.slideNode.parentNode.classList.contains('slick-active');

  render() {
    const { media, text, ...rest } = this.props;
    const video = media.content.assets[0];

    return (
      <Styled {...rest} innerRef={node => (this.slideNode = node)}>
        <StyledMedia
          src={video.path}
          type={`video/${video.type}`}
          loop
          autoPlay
          playsInline
          active={this.state.active}
        />
        <Text>{text}</Text>
      </Styled>
    );
  }
}

export default Slide;



// WEBPACK FOOTER //
// ./src/scenes/Approach/components/Carousel/components/Slide.js